import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "black";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    fontSize: 9,
  },
  description: {
    width: "85%",
    textAlign: "right",
    paddingRight: 8,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    backgroundColor: "#cfd8dc",
  },
  total: {
    width: "15%",
    textAlign: "center",
    borderRightWidth: 1,
    backgroundColor: "#cfd8dc",
  },
  Realtotal: {
    width: "15%",
    textAlign: "center",
    borderRightWidth: 1,
    backgroundColor: "#263238",
    color: "white",
  },
  RealtotalLabel: {
    width: "85%",
    textAlign: "right",
    paddingRight: 8,
    borderRightColor: borderColor,
    borderRightWidth: 1,
    backgroundColor: "#263238",
    color: "white",
  },
});
const InvoiceTableFooter = ({ invoice }) => {


  let cal = 0;
  const total = invoice.items?.map((item) => {
    cal = cal + item.quantity * item.customer_price;
  });
  const Shipping_Cost = parseFloat(invoice.Shipping_Cost);
  const Tax = parseFloat(invoice.Tax);
  const OtherCost = JSON.parse(invoice.Other_Cost);


  return (
    <>
      {Shipping_Cost !== 0 && (
        <View style={styles.row}>
          <Text style={styles.description}>Shipping Cost</Text>
          <Text style={styles.total}>
            {"$" +
              Shipping_Cost.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
          </Text>
        </View>
      )}
      {Tax !== 0 && (
        <View style={styles.row}>
          <Text style={styles.description}>Tax</Text>
          <Text style={styles.total}>
            {"$" +
              Tax.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
          </Text>
        </View>
      )}

  {Array.isArray(OtherCost) && OtherCost.length !== 0 &&
              OtherCost.map((item, index) => (
                <View style={styles.row} key={index}>
                  <Text style={styles.description}>{item.Name}</Text>
                  <Text style={styles.total}>
                    {`$${item.Amount.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
                  </Text>
                </View>
              ))
            }
      <View style={styles.row}>
        <Text style={styles.RealtotalLabel}>TOTAL</Text>
        <Text style={styles.Realtotal}>
          {"$" +
            Number.parseFloat(invoice.Total_Cost).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
        </Text>
      </View>
    </>
  );
};

export default InvoiceTableFooter;
